<template>
  <ion-page>
    <ion-content class="ion-padding bg-grad-content">
      <ion-slides ref="aboutSlide">
        <ion-slide>
          <div class="slide">
            <img
              src="https://lion.com.co/assetver_app_2_1_02052020/images/corp/nosotros-img-1.png"
            />
            <h2>A QUÉ NOS DEDICAMOS</h2>
            <p>
              Somos una compañía colombiana dedicada al diseño, producción y
              comercialización de productos en acero inoxidable para la
              protección y personalización de motocicletas, con más de siete
              años de experiencia en el mercado.
            </p>
            <p>
              Contamos con un departamento de importaciones el cual juega un
              papel relevante en la organización, gracias a este tenemos la
              posibilidad de brindar variedad de productos de calidad, los
              cuales permiten que rodar en la motocicleta sea más seguro y
              confortable.
            </p>
            <p>
              Dichos accesorios aportan a la mejoría estética y el performance
              de la motocicleta.
            </p>
          </div>
        </ion-slide>

        <ion-slide>
          <img
            src="https://lion.com.co/assetver_app_2_1_02052020/images/corp/nosotros-img-2.png"
          />
          <div class="description">
            <h2 class="header-text">NUESTRA MOTIVACIÓN</h2>
            <p class="t-r">
              <strong>MISIÓN:</strong> Garantizar la satisfacción de nuestros
              clientes con productos de calidad, brindando un servicio que
              solucione las necesidades y cumpla con las expectativas de todas
              las personas interesadas en nuestros productos y/o servicios.
            </p>
            <p class="t-r">
              <strong>VISIÓN:</strong> En cinco años ser la compañía líder a
              nivel nacional en diseño, fabricación, variedad de
              productos/servicios para la protección y personalización de
              motocicletas.
            </p>

            <p class="t-r">
              Con LION accesorios. ¡Diseña tu pasión
            </p>
          </div>
        </ion-slide>

        <ion-slide>
          <img
            src="https://lion.com.co/assetver_app_2_1_02052020/images/moto_brand/all_brand.png"
          />
          <h2>PODEMOS OFRECER PRODUCTOS PARA ESTAS MARCAS</h2>
          <ion-button fill="clear" @click="$router.push({ name: 'home' })"
            >Continuar <ion-icon slot="end" name="arrow-forward"></ion-icon
          ></ion-button>
        </ion-slide>
      </ion-slides>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
  ionViewDidEnter() {
    let swiper = this.$refs.aboutSlide
    swiper.$el.slideTo(0, 100)
    this.$emitter.emit('full-loader')
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    this.$emitter.emit('full-loader', { open: true })
  },
  ionViewWillLeave() {}
}
</script>

<style scoped>
.swiper-slide {
  display: block;
}

.swiper-slide h2 {
  margin-top: 2.8rem;
}

.swiper-slide img {
  max-width: 90%;
  margin: 60px 0 40px;
  pointer-events: none;
  border-radius: 10px;
}

b {
  font-weight: 500;
}

p {
  padding: 0 40px;
  font-size: 14px;
  line-height: 1.5;
}
</style>
